import * as React from 'react';
import { PageHeader } from '../common';

export const AboutContainer: React.SFC<{}> = () => (
  <>
    <PageHeader>About</PageHeader>
    <p>What's this all about?</p>
  </>
);


// WEBPACK FOOTER //
// ./src/containers/about.tsx